import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Link,
} from "@material-ui/core";
import ButtonWithSpinner from "../../ButtonWithSpinner/ButtonWIthSpinner";

const CancelPlanConfirmationModal = (props) => {
  const { showFinalConfirmation, setShowFinalConfirmation, onClick, loading } =
    props;
  return (
    <Dialog
      open={showFinalConfirmation}
      onClose={() => setShowFinalConfirmation(false)}
      aria-labelledby="final-confirmation-title"
    >
      <DialogTitle id="final-confirmation-title">
        <b>Just one more thing...</b>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          👉 <strong>Did you know ChurchBee is included in your plan?</strong>
        </Typography>
        <Typography variant="body2">
          Enjoy templates, email builder, integrations and more.{" "}
          <Link href="https://bee.church/" target="_blank" rel="noopener">
            Learn more
          </Link>
        </Typography>
      </DialogContent>
      <DialogActions className="mt-3 mb-2">
        <ButtonWithSpinner
          onClick={() => setShowFinalConfirmation(false)}
          className="dark-gray-button"
        >
          Go Back
        </ButtonWithSpinner>
        <ButtonWithSpinner
          loading={loading}
          onClick={onClick}
          className="bg-yellow"
        >
          Yes, still cancel
        </ButtonWithSpinner>
      </DialogActions>
    </Dialog>
  );
};

export default CancelPlanConfirmationModal;
